import * as Yup from 'yup';
import { sharedTestSchemaValidation } from './RunTestSharedSchema';

export const runSingleTestSchema = (isSuperAdmin: boolean) =>
  Yup.object().shape({
    tests: Yup.array().of(sharedTestSchemaValidation(isSuperAdmin)).min(1, 'At least one test is required')
  });
